export default __webpack_public_path__ + "static/media/216.d819ac85.jpg";